var fsApiKey = '62d4311be3e9bd5db4bb6d11eca23421';

const processProductCard = async (container) => {
  const productId = container.getAttribute("data-product-id");
  if (!productId) return;

  const response = await fetch(`https://kave-home-serbia.myshopify.com/api/2024-04/graphql.json`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": fsApiKey,
    },
    body: JSON.stringify({
      query: `
        query {
          product(id: "gid://shopify/Product/${productId}") {
            collections(first: 99) {
              edges {
                node {
                  title
                  handle
                  metafields: metafield(namespace: "custom", key: "is_main_collection") {
                    value
                  }
                }
              }
            }
          }
        }
      `
    }),
  });

  const json = await response.json();
  const collections = json?.data?.product?.collections?.edges ?? [];

  for (const { node } of collections) {
    if (node.metafields?.value === "true") {
      container.innerHTML = `<a href="/collections/${node.handle}" class="custom-main-collection">${node.title}</a>`;
      container.classList.add("completed");
      break;
    }
  }
};

const observeProductCards = () => {
  const processAll = () => {
    const containers = document.querySelectorAll(".product-card-main-collection:not(.completed)");
    containers.forEach(container => {
      container.classList.add("completed");
      processProductCard(container);
    });
  };

  // Primera pasada
  processAll();

  // Observar cambios en el DOM
  const observer = new MutationObserver(() => {
    processAll();
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

observeProductCards();
